<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M27.6127 11.4611H23.1831C22.8959 11.4611 22.6641 11.2251 22.6641 10.9327C22.6641 10.6403 22.8959 10.4043 23.1831 10.4043H27.6127C27.8999 10.4043 28.1318 10.6403 28.1318 10.9327C28.1318 11.2251 27.8999 11.4611 27.6127 11.4611Z"
			:fill="props.iconColor"
		/>
		<path
			d="M44.1058 14.6276H5.88727C4.76951 14.6276 3.85938 13.7011 3.85938 12.5633C3.85938 11.6967 4.39922 10.9146 5.19862 10.6187L24.8131 3.03435C24.9308 2.98855 25.0623 2.98855 25.1834 3.03435L44.8049 10.6222C45.5973 10.9146 46.1372 11.6932 46.1372 12.5633C46.1372 13.7011 45.2271 14.6276 44.1093 14.6276H44.1058ZM24.9966 4.09116L5.55852 11.6121C5.15709 11.7601 4.89409 12.1405 4.89409 12.5633C4.89409 13.1198 5.33704 13.5708 5.88381 13.5708H44.1024C44.6491 13.5708 45.0921 13.1163 45.0921 12.5633C45.0921 12.1405 44.8291 11.7566 44.4381 11.6157L24.9966 4.09116Z"
			:fill="props.iconColor"
		/>
		<path
			d="M27.5867 39.1747H22.4097C22.1225 39.1747 21.8906 38.9387 21.8906 38.6463V18.0597C21.8906 17.7673 22.1225 17.5312 22.4097 17.5312H27.5867C27.874 17.5312 28.1058 17.7673 28.1058 18.0597V38.6463C28.1058 38.9387 27.874 39.1747 27.5867 39.1747ZM22.9288 38.1179H27.0676V18.5881H22.9288V38.1179Z"
			:fill="props.iconColor"
		/>
		<path
			d="M16.6336 39.1747H11.4566C11.1694 39.1747 10.9375 38.9387 10.9375 38.6463V18.0597C10.9375 17.7673 11.1694 17.5312 11.4566 17.5312H16.6336C16.9208 17.5312 17.1527 17.7673 17.1527 18.0597V38.6463C17.1527 38.9387 16.9208 39.1747 16.6336 39.1747ZM11.9757 38.1179H16.1145V18.5881H11.9757V38.1179Z"
			:fill="props.iconColor"
		/>
		<path
			d="M38.5438 39.1747H33.3667C33.0795 39.1747 32.8477 38.9387 32.8477 38.6463V18.0597C32.8477 17.7673 33.0795 17.5312 33.3667 17.5312H38.5438C38.831 17.5312 39.0628 17.7673 39.0628 18.0597V38.6463C39.0628 38.9387 38.831 39.1747 38.5438 39.1747ZM33.8858 38.1179H38.0247V18.5881H33.8858V38.1179Z"
			:fill="props.iconColor"
		/>
		<path
			d="M46.2618 47.0002H3.74174C3.45451 47.0002 3.22266 46.7641 3.22266 46.4718C3.22266 46.1794 3.45451 45.9434 3.74174 45.9434H46.2618C46.549 45.9434 46.7809 46.1794 46.7809 46.4718C46.7809 46.7641 46.549 47.0002 46.2618 47.0002Z"
			:fill="props.iconColor"
		/>
		<path
			d="M41.8415 43.1349H8.15971C7.87248 43.1349 7.64062 42.8989 7.64062 42.6065C7.64062 42.3141 7.87248 42.0781 8.15971 42.0781H41.8415C42.1287 42.0781 42.3606 42.3141 42.3606 42.6065C42.3606 42.8989 42.1287 43.1349 41.8415 43.1349Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
